import * as React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ChatInfoLine from "./InfoLine";
import {ChatDestinationEntry} from "./Chat";

interface ChatDestinationSelectProps {
    destinationEntries: ChatDestinationEntry[];
    contactOption: string;
    handleDestinationSelection: (entryObj: ChatDestinationEntry, contactOption: string) => void;
}

export default function ChatDestinationSelect(props: ChatDestinationSelectProps) {

    return <>
        <Grid item pb={1}>
            <Typography>Wählen Sie hier einen unserer Bereiche:</Typography>
        </Grid>

        <Grid item>
            {props.destinationEntries.map((entryObj: ChatDestinationEntry, index: number) => {
                return <div className={'chat-destination'} key={index} onClick={() => props.handleDestinationSelection(entryObj, props.contactOption)}>
                    <ChatInfoLine icon={entryObj.icon} text={entryObj.name}/>
                </div>
            })}
        </Grid>
    </>
}